import axios from "axios";
import { endsSession } from "./sessionEnd";

const api = axios.create({
     baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

// 1. Request Interceptor
api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 2. Response Interceptor
api.interceptors.response.use(
    (response) => {
        // If the request succeeds
        return response;
    },
    (error) => {
        // If the request fails...
        if (error.response) {
            const { status, data } = error.response;

            // Log out only when the session/account is unusable; a permission refusal stays on the page.
            if (endsSession(status, data)) {
                localStorage.removeItem("jwtToken");

                // Force a hard redirect to login page
                window.location.href = "/login";
            }
        }

        // Pass the error along (so your specific page can stop loading spinners, etc.)
        return Promise.reject(error);
    }
);

export { api };
